module.exports = __webpack_public_path__ + "img/d254c3c.jpg";